module.exports = __webpack_public_path__ + "img/boxed-11.1cc78ba9.jpg";